import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '../Box';
import { Icon, IconProps } from '../Icon';

type DropdownIndicatorProps = Omit<IconProps, 'name'>;

export const DropdownIndicator = forwardRef<
  HTMLDivElement,
  DropdownIndicatorProps
>((props: DropdownIndicatorProps, ref) => {
  const { t } = useTranslation('common', { useSuspense: false });

  return (
    <Box cursor="pointer" ref={ref} data-testid="dropdown-indicator">
      <Icon
        color="tertiary.700"
        cursor="pointer"
        size={24}
        {...props}
        aria-label={t('more')!}
        name="more"
        tabIndex={0}
      />
    </Box>
  );
});
